import { IconName, IconPrefix, IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { Modal, SearchBox } from 'uxp/components';
import Icons from './IconData';

function generateIconClass(icon: string,) {
    if (!Icons[icon]) return '';
    let iconName = Icons[icon].icon;
    let style = Icons[icon].style.substring(0, 1);
    return `fa${style} fa-${iconName}`;
}

function generateIconProp(icon: string): null | IconProp {
    if (!Icons[icon]) return null
    let style = Icons[icon].style.substring(0, 1);
    let prefix: IconPrefix = `fa${style}` as IconPrefix
    let name: IconName = Icons[icon].icon as IconName
    return [prefix, name];
}
function generateIconPropAsSting(icon: string): string {
    if (!Icons[icon]) return null
    let style = Icons[icon].style.substring(0, 1);
    let prefix: IconPrefix = `fa${style}` as IconPrefix
    let name: IconName = Icons[icon].icon as IconName
    return `${prefix} ${name}`;
}
interface IIConEditorProps {
    value: string;
    onChange: (value: string) => void;
}

var IconKeys = Object.keys(Icons);

const IconEditor: React.FunctionComponent<IIConEditorProps> = (props) => {

    let [query, setQuery] = React.useState('');
    let [isPickerOpen, setIsPickerOpen] = React.useState(false);

    let filteredIcons = IconKeys;

    if (query) {
        filteredIcons = IconKeys.filter(icon => {
            return icon.toUpperCase().indexOf(query.toUpperCase()) > -1;
        });
    }

    return <div className='wd-icon-editor'>

        <div
            onClick={() => setIsPickerOpen(true)}
            className={`icon-preview`}
        >
            <FontAwesomeIcon icon={generateIconProp(props.value)} />
        </div>
        <Modal
            headerContent={<div className='icon-header'>
                <div className="title">Search Icons</div>
                <SearchBox value={query} onChange={setQuery} placeholder="start typing..." />
            </div>}

            className={'wd-icon-editor-modal'}
            show={isPickerOpen}
            onClose={() => { setIsPickerOpen(false); setQuery("") }}
        >
            <div className='icon-selection'>
                {filteredIcons.map((icon) => {
                    return <div
                        key={icon}
                        className={'icon-picker ' + (icon == props.value ? 'selected' : '')}
                        onClick={() => {
                            props.onChange(icon);
                            setIsPickerOpen(false);
                        }} >
                        <FontAwesomeIcon icon={generateIconProp(icon)} />
                    </div>;
                })}
            </div>

        </Modal>
    </div>;
};
export { IconEditor, generateIconClass, generateIconProp, generateIconPropAsSting };
